import { EntityStatus, ShareholderExtendResponse } from 'api';

export const getKycFallbackMessage = (shareholder?: ShareholderExtendResponse | null) => {
  const status = shareholder?.entity?.status;
  const rejectionReason = shareholder?.entity?.entity_application_rejection_reason?.trim();

  if (status === EntityStatus.EntityApproved) {
    return "Our KYC provider cannot verify this holder's information; this holder has been approved by the issuer admin";
  }

  if (status === EntityStatus.EntityAwaitingApproval) {
    return "Our KYC provider cannot verify this holder's information; the issuer admin must approve or decline this holder";
  }

  if (status === EntityStatus.EntityUnsuccessfull) {
    return rejectionReason
      ? `This holder was unsuccessful in KYC. Reason: ${rejectionReason}`
      : 'This holder was unsuccessful in KYC and requires follow-up or correction before proceeding';
  }

  return 'KYC for this entity has been done outside of our KYC provider';
};
